var React = require('react');

function BracketClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Group-385","transform":"translate(-1.000000, -1.000000)","fill":"#FFFFFF","fillRule":"nonzero"},React.createElement("g",{"id":"Group_385","transform":"translate(9.006000, 38.475000) rotate(180.000000) translate(-9.006000, -38.475000) translate(0.506000, 0.475000)"},React.createElement("path",{"d":"M16.506,0.878 C7.68043591,11.3126634 2.79354681,24.5118642 2.696,38.178 C2.68942927,45.0660214 3.95673911,51.8958653 6.434,58.323 C8.77708157,64.5789958 12.1846477,70.3825492 16.506,75.477 L0.848,75.477 L0.848,0.877 L16.506,0.878 Z","id":"Path_613"})))));
}

BracketClose.defaultProps = {"width":"16px","height":"75px","viewBox":"0 0 16 75","version":"1.1"};

module.exports = BracketClose;

BracketClose.default = BracketClose;
